import React, { useEffect, useMemo, useRef, useState } from "react";
import Header from "../../layout/Header";
import { getColumns } from "./listColumn";
import { getDisplayDate } from "../../../../utils/helper";
import Paginated from "./Paginated";
import TemplateTable from "./TemplateTable";
import {
    getDynamicdata,
    getQRCode,
    // getQRTemplate,
    GetQRDataByCode,
    updateQRStatus,
} from "../../../../components/pages/campaigns/services";
import { Button, Modal } from "react-bootstrap";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import { decrypt } from "../../../../utils/encodingdecoding";
import { arjunMerchantId, starblazeMerchantId } from "../../../../utils";
// import { Link } from "react-router-dom";

const QRCodeList = () => {
    const [loader, setLoader] = useState(false);
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [qrCount, setQrCount] = useState(0);

    const [templates, setTemplates] = useState([]);
    const [templateList, setTemplateList] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [selectedBatch, setSelectedBatch] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState("");

    const [showModal, setShowModal] = useState(false);
    const [selectedQR, setSelectedQR] = useState(null);

    const currentPage = JSON.parse(localStorage.getItem("QRPageIndex")) || 1;
    const merCode = localStorage.getItem("Id");
    const [showCustomerColumns, setShowCustomerColumns] = useState(false);
    // QR table is shown only after a QR code is searched
    const [hasSearched, setHasSearched] = useState(false);
    const [templatePageSize, setTemplatePageSize] = useState(10);
    const COLUMNS = useMemo(() => getColumns(showCustomerColumns), [showCustomerColumns]);

    useEffect(() => {
        localStorage.setItem("QRPageIndex", JSON.stringify(1));
        initTemplates();
    }, []);

    // Same API as All QR Logs (getDynamicdata) - each generated QR batch is one row
    const initTemplates = async () => {
        try {
            setLoader(true);
            const tokenRes = JSON.parse(localStorage.getItem("token_gen"));

            // const templateRes = await getQRTemplate(tokenRes.access_token);
            const logsRes = await getDynamicdata(tokenRes.access_token, "", "");
            const logs = logsRes?.data || [];

            // Product details per template code, used for Product Name in search results / file names
            const productList = logs
                .map((val) => val?.requestData)
                .filter((req) => req?.code);

            const rows = logs.map((val) => ({
                templateCode: val?.requestData?.code,
                useremail: val?.requestData?.discriminatorType,
                productdescription: (val?.requestData?.productName || "").replace(/\s+/g, " ").trim(),
                batchno: val?.requestData?.others?.subCategory,
                quantity: val?.requestData?.quantity,
                value: val?.requestData?.value,
                datetime: val?.CreatedDate ? getDisplayDate(val?.CreatedDate) : "",
            })).reverse();

            setTemplates(productList);
            setTemplateList(rows);
        } catch (err) {
            console.error("QR Logs API error:", err);
        } finally {
            setLoader(false);
        }
    };

    // Initial QR list load disabled - QR codes are shown only via Search,
    // products are listed in the product table with a download per row
    // useEffect(() => {
    //     if (selectedTemplate || selectedBatch) {
    //         fetchQRList(currentPage, 50, selectedTemplate, selectedBatch);
    //     }
    // }, [selectedTemplate, selectedBatch, selectedStatus]);

    // Same rule as the table: "Active" = Un Scan, anything else = Scanned
    const filterByStatus = (rows) => {
        if (selectedStatus === "Active") return rows.filter((ele) => ele.status === "Active");
        if (selectedStatus === "InActive") return rows.filter((ele) => ele.status !== "Active");
        return rows;
    };

    // Cache of all raw rows for the current template/batch, used for client-side status filtering
    const allRowsCache = useRef({ key: null, rows: [] });

    const fetchAllRawQR = async (templateCode, batchNo = "") => {
        const key = `${templateCode || ""}|${batchNo || ""}`;
        if (allRowsCache.current.key === key) return allRowsCache.current.rows;

        const tokenRes = JSON.parse(localStorage.getItem("token_gen"));
        const pageSize = 1000;
        let page = 1;
        let totalCount = 0;
        let allRows = [];

        do {
            const response = await getQRCode(
                tokenRes.access_token,
                merCode,
                templateCode,
                batchNo,
                page,
                pageSize
            );

            if (response?.message !== "Record fetched successfully." || !response?.data?.length) break;

            allRows = allRows.concat(response.data);
            totalCount = Number(response.totalCount) || 0;
            page++;
        } while (allRows.length < totalCount);

        allRowsCache.current = { key, rows: allRows };
        return allRows;
    };

    const mapQRRow = (ele) => {
        const matchedProduct = templates.find(
            (p) => p.code === ele.templatecode
        );

        return {
            ...ele,
            qr: ele.qrcode ?? "",
            encryptCode: ele.code
                ? ele.code.toString().slice(0, -4) + "****"
                : "",
            productName: matchedProduct?.productName || "",
            status:
                ele.status === "Active" ? (
                    "Un Scan"
                ) : (
                    <span class="text-danger"
                    // style={{ color: "red", cursor: "pointer" }}
                    // onClick={() => handleShow(ele)}
                    >
                        Scanned
                    </span>
                ),
            createddate: getDisplayDate(ele.createddate),
            scandate: ele.status?.toLowerCase() === "inactive" ?
                getDisplayDate(ele.updateddate) : "",
            // customerCode: <Link to={`/customer-view/${ele?.customerCode}`}>{ele?.customerCode}</Link>

        };
    };

    const searchQRByCode = async (qrCode) => {
        if (!qrCode?.trim()) {
            setShowCustomerColumns(false);
            setFilteredData(data);
            setHasSearched(false);
            return;
        }
        setHasSearched(true);
        try {
            setLoader(true);
            const tokenRes = JSON.parse(localStorage.getItem("token_gen"));
            const response = await GetQRDataByCode(tokenRes.access_token, qrCode.trim());
            const qrData = response?.data?.qrData;
            if (!qrData) {
                setShowCustomerColumns(false);
                setFilteredData([]);
                return;
            }
            const transactions = response?.data?.qrTransaction || [];
            const row = mapQRRow({
                ...qrData,
                templatecode: qrData.templateCode,
                createddate: qrData.createdDate,
                updateddate: transactions[0]?.transactionProcessedDate || qrData.updatedDate,
            });
            if (transactions.length) {
                row.customerName = transactions[0]?.customer?.[0]?.name || "";
            }
            setShowCustomerColumns(transactions.length > 0);
            setFilteredData([row]);
        } catch (err) {
            console.error("QR search error:", err);
            setShowCustomerColumns(false);
            setFilteredData([]);
        } finally {
            setLoader(false);
        }
    };

    const fetchQRList = async (page, pageSize = 50, templateCode, selectedBatch) => {
        try {
            setLoader(true);
            setShowCustomerColumns(false);

            if (selectedStatus) {
                const filtered = filterByStatus(await fetchAllRawQR(templateCode, selectedBatch));
                const pageRows = filtered
                    .slice((page - 1) * pageSize, page * pageSize)
                    .map(mapQRRow)
                    .reverse();
                setData(pageRows);
                setFilteredData(pageRows);
                setQrCount(filtered.length);
                return;
            }

            const tokenRes = JSON.parse(localStorage.getItem("token_gen"));

            const response = await getQRCode(
                tokenRes.access_token,
                merCode,
                templateCode,
                selectedBatch,
                page,
                pageSize
            );

            if (response?.message === "Record fetched successfully.") {
                const mappedData = response.data.map(mapQRRow);

                const reversed = mappedData.reverse();
                setData(reversed);
                setFilteredData(reversed);
                setQrCount(response.totalCount);
            } else {
                setData([])
                setQrCount(0);
                setFilteredData([]);
            }
        } catch (err) {
            console.error("QR fetch error:", err);
        } finally {
            setLoader(false);
        }
    };

    const handleShow = (qr) => {
        setSelectedQR(qr);
        setShowModal(true);
    };

    const handleClose = () => setShowModal(false);

    const updateQRCodeStatus = async () => {
        try {
            setLoader(true);
            const tokenRes = JSON.parse(localStorage.getItem("token_gen"));
            await updateQRStatus(tokenRes.access_token, selectedQR?.code, "Active");
            allRowsCache.current = { key: null, rows: [] };
            fetchQRList(currentPage, 50, selectedTemplate);
        } finally {
            setLoader(false);
        }
    };

    const fetchAllQRByTemplate = async (templateCode, batchNo = "") => {
        if (!templateCode && !batchNo) {
            alert("Please select a product to download.");
            return [];
        }
        try {
            setLoader(true);
            allRowsCache.current = { key: null, rows: [] };
            const allRows = filterByStatus(await fetchAllRawQR(templateCode, batchNo));

            if (allRows.length) {
                return allRows.map((ele) => {
                    const matchedProduct = templates.find(
                        (p) => p.code === ele.templatecode
                    );

                    return {
                        ...ele,
                        qr: ele.qrcode ?? "",
                        productName: matchedProduct?.productName || "",
                        isassigned: ele.isassigned?.toString(),
                        createddate: getDisplayDate(ele.createddate, "DD-MM-YYYY"),
                        status: ele.status === "Active" ? "Un Scan" : "Scan",
                    };
                });
            }

            return [];
        } catch (error) {
            console.error("fetchAllQRByTemplate error:", error);
            return [];
        } finally {
            setLoader(false);
        }
    };


    const getDownloadFileName = (suffix, templateCode = selectedTemplate) => {
        const product = templates.find((p) => p.code === templateCode);
        const name = (product ? [product.productName, product?.others?.subCategory].filter(Boolean).join("_") : selectedBatch || "QR_Code")
            .replace(/\s+/g, " ").trim().replace(/[\\/:*?"<>|]/g, "_");
        return `${name}_${suffix}`;
    };

    const handleDownloadCSV = async (templateCode = selectedTemplate, batchNo = selectedBatch) => {
        const allData = await fetchAllQRByTemplate(templateCode, batchNo);
        if (!allData.length) return;

        try {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("QR Code Data");

            const hasQrImage = decrypt(merCode) !== starblazeMerchantId &&
                allData.some(
                    (row) => row.qr && row.qr.startsWith("data:image")
                );

            const headers = hasQrImage
                ? [
                    "QR Image",
                    "QR Code",
                    "Template Code",
                    "Product Name",
                    "Is Assign",
                    "Created Date",
                    "Status",
                ]
                : [
                    "QR Code",
                    "Template Code",
                    "Product Name",
                    "Is Assign",
                    "Created Date",
                    "Status",
                ];

            worksheet.columns = headers.map((key) => ({
                header: key,
                key,
                width: key === "QR Image" ? 20 : 30,
            }));

            allData.forEach((row, index) => {
                const rowIndex = index + 2;

                // createddate is already formatted (DD-MM-YYYY) in fetchAllQRByTemplate
                const formattedDate = row.createddate || "";

                const newRow = {
                    "QR Code": row.code ?? "",
                    "Template Code": row.templatecode ?? "",
                    "Product Name": row.productName ?? "",
                    "Is Assign": row.isassigned ? "Yes" : "No",
                    "Created Date": formattedDate,
                    "Status": typeof row.status === "string" ? row.status : "Scan",
                };

                worksheet.addRow(newRow);

                if (hasQrImage) {
                    worksheet.getRow(rowIndex).height = 90;
                }

                if (
                    hasQrImage &&
                    row.qr &&
                    row.qr.startsWith("data:image")
                ) {
                    const imageId = workbook.addImage({
                        base64: row.qr,
                        extension: "png",
                    });

                    worksheet.addImage(imageId, {
                        tl: { col: 0, row: rowIndex - 1 },
                        ext: { width: 90, height: 90 },
                    });
                }
            });

            const buffer = await workbook.xlsx.writeBuffer();

            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            saveAs(blob, getDownloadFileName("QR_Code_Data.xlsx", templateCode));
        } catch (error) {
            console.error("Error generating Excel:", error);
        }
    };

    const handleDownloadQRImagesZip = async () => {
        const allData = await fetchAllQRByTemplate(selectedTemplate, selectedBatch);

        if (!allData.length) return;

        try {
            const zip = new JSZip();
            const qrFolder = zip.folder("QR_Codes");

            for (let index = 0; index < allData.length; index++) {
                const row = allData[index];

                if (!row.qr) continue;

                const imageBlob = await createQRImageWithCode(
                    row.qr,
                    row.code || `QR_${index + 1}`
                );

                const arrayBuffer = await imageBlob.arrayBuffer();

                const fileName = row.code
                    ? `${row.code}.png`
                    : `qr_${index + 1}.png`;

                qrFolder.file(fileName, arrayBuffer);
            }

            const zipBlob = await zip.generateAsync({
                type: "blob",
            });

            saveAs(zipBlob, getDownloadFileName("QR_Code_Images.zip"));
        } catch (error) {
            console.error("Error generating QR ZIP:", error);
        }
    };

    const createQRImageWithCode = (base64Image, code) => {
        return new Promise((resolve, reject) => {
            const img = new Image();

            img.onload = () => {
                const padding = 20;
                const textAreaHeight = 50;

                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                canvas.width = img.width + padding * 2;
                canvas.height =
                    img.height +
                    textAreaHeight +
                    padding * 2;

                // White background
                ctx.fillStyle = "#FFFFFF";
                ctx.fillRect(
                    0,
                    0,
                    canvas.width,
                    canvas.height
                );

                // Draw QR Image
                ctx.drawImage(
                    img,
                    padding,
                    padding,
                    img.width,
                    img.height
                );

                // Optional separator line
                ctx.beginPath();
                ctx.moveTo(
                    padding,
                    img.height + padding + 5
                );
                ctx.lineTo(
                    canvas.width - padding,
                    img.height + padding + 5
                );
                ctx.strokeStyle = "#000";
                ctx.stroke();

                // Draw code text
                ctx.fillStyle = "#000";
                ctx.font = "bold 30px Arial";
                ctx.textAlign = "center";

                ctx.fillText(
                    code,
                    canvas.width / 2,
                    img.height + padding + 35
                );

                canvas.toBlob(
                    (blob) => {
                        if (blob) {
                            resolve(blob);
                        } else {
                            reject(
                                new Error(
                                    "Failed to create image blob"
                                )
                            );
                        }
                    },
                    "image/png",
                    1
                );
            };

            img.onerror = reject;

            img.src = base64Image.startsWith("data:image")
                ? base64Image
                : `data:image/png;base64,${base64Image}`;
        });
    };

    return (
        <>
            <Header name={"QR Codes"} />
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="dashboard__transactionsCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4 id='transction_list'>All QR Code List</h4>
                            </div>
                            <div className="dashboard__right d-flex gap-2">
                            </div>
                        </div>
                        <div className="dashboard__body">
                            <div className="dashboard__heading" style={{ justifyContent: "end", marginBottom: "0" }}>
                                <div className="dashboard__headingRight">
                                    <div className="form-group">
                                    </div>
                                </div>
                            </div>
                            <Paginated
                                data={filteredData}
                                originalData={data}
                                setFilteredData={setFilteredData}
                                columns={COLUMNS}
                                templateList={templateList}
                                fetch={fetchQRList}
                                onSearch={searchQRByCode}
                                qrCount={qrCount}
                                selectedTemplate={selectedTemplate}
                                setSelectedTemplate={setSelectedTemplate}
                                selectedBatch={selectedBatch}
                                setSelectedBatch={setSelectedBatch}
                                selectedStatus={selectedStatus}
                                setSelectedStatus={setSelectedStatus}
                                showTable={hasSearched}
                                headerLeft={!hasSearched && (
                                    <div className="customTable__showingRecords">
                                        <div className="form-group">
                                            <label>Show Records:</label>
                                            <select
                                                className="form-control selectArrow"
                                                value={templatePageSize}
                                                onChange={(e) => setTemplatePageSize(Number(e.target.value))}
                                            >
                                                {[10, 25, 50].map((size) => (
                                                    <option key={size} value={size}>
                                                        {size}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                )}
                            >
                                <TemplateTable
                                    data={templateList}
                                    onDownload={handleDownloadCSV}
                                    pageSize={templatePageSize}
                                />
                            </Paginated>
                        </div>
                    </div>
                </div>
            </div>
            <Modal Modal
                show={showModal}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title style={{ fontSize: "16px", fontWeight: 600 }}>
                        Reverse Scan
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Do you want to reverse the scan for QR Code: <strong>{selectedQR?.code}</strong>?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Close</Button>
                    <Button variant="primary" onClick={() => {
                        updateQRCodeStatus()
                        handleClose();
                    }}>Reverse Scan</Button>
                </Modal.Footer>
            </Modal >
        </>
    );
};

export default QRCodeList





